
import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { IAppState } from '../store';
import { AppContext } from './models/app.context';

export const APP_CONTEXT = 'app/CONTEXT';



@Injectable()
export class AppActions {


    constructor(private ngRedux: NgRedux<IAppState>) {

    }



    appContext(appContext: AppContext) {
        this.ngRedux.dispatch({
            type: APP_CONTEXT,
            appContext
        });
        return {
            type: APP_CONTEXT,
            appContext
        };
    }

}